import { render, staticRenderFns } from "./GroupMemberInfoExpand.vue?vue&type=template&id=69fa4ff2"
import script from "./GroupMemberInfoExpand.vue?vue&type=script&lang=js"
export * from "./GroupMemberInfoExpand.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberInfoExpand.vue?vue&type=style&index=0&id=69fa4ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports